import styled from 'styled-components';

export const WhiteWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  max-width: 50rem;
  border-radius: 0.75rem;
  background-color: white;
  padding: 3.75rem;
  margin: 1rem;
  animation: simpleFadeIn 0.3s ease-in-out;
`;
